import React from 'react'
import CreateUpdateProject from './CreateUpdateProject'
import { type Project } from '@/redux/service/project'

interface ProjectDetailsProps {
  open: boolean
  onClose: () => void
  data: Project | null
}

const ProjectDetails: React.FC<ProjectDetailsProps> = ({
  open,
  onClose,
  data,
}) => {
  return (
    <CreateUpdateProject
      open={open}
      onClose={onClose}
      project_id={data?.project_id}
      list_id={data?.list_id}
      project_type={data?.project_type}
    />
  )
}

export default ProjectDetails
